import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from './router.js';
import { setLocale } from './i18n/index.js';
import { AuthProvider } from './store/AuthContext.js';
import './styles/global.css';

setLocale('fr');

const container = document.getElementById('root');
if (!container) {
  throw new Error('Element racine introuvable : le document HTML est incomplet.');
}

createRoot(container).render(
  <StrictMode>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </StrictMode>,
);
